import React, { Component } from 'react';
import { 
  Modal, 
  Button, 
  Row, 
  Col, 
  Form, 
  FormGroup, 
  ControlLabel, 
  FormControl, 
  Alert 
} from 'react-bootstrap';
import Dropdown from 'react-dropdown';

const sectors = [
  { label: 'discretionary', value: 'XLY' },
  { label: 'staples', value: 'XLP' },
  { label: 'energy', value: 'XLE' },
  { label: 'financials', value: 'XLF' },
  { label: 'reits', value: 'XLRE' },
  { label: 'healthcare', value: 'XLV' },
  { label: 'industrials', value: 'XLI' },
  { label: 'technology', value: 'XLK' },
  { label: 'materials', value: 'XLB' },
  { label: 'utilities', value: 'XLU' },
  { label: 'communication services', value: 'XLC' },
];

class AddRemoveModal extends Component {  
  constructor(props) {
    super(props);

    this.state = {
      symbol: '',
      sector: null,
      error: ''
    };
  }

  onFinish = (type) => {
    const { symbol, sector } = this.state;
    if (!symbol || !sector) {
      this.setState({ error: 'Please fill in all fields.' });
    } else {
      this.props.onAddRemove({ 
        type, 
        symbol: symbol.toUpperCase(),
        sector: sector.value, 
        activePortfolioId: this.props.activePortfolioId 
      });
      this.closeModal();
    }
  }

  closeModal = () => {
    this.setState({ symbol: '', sector: null, error: '' });
    this.props.closeModal('showAddRemoveModal');
  }

  renderAlert = () => {
    if (this.state.error) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {this.state.error}
        </Alert>
      );
    }
  }

  render() {
    return (
      <Modal show={this.props.showAddRemoveModal} onHide={() => this.closeModal()} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add / Remove</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col mdOffset={2} md={8}>
              <Form onSubmit={(e) => e.preventDefault()}>
                <FormGroup controlId="symbol">
                  <ControlLabel>Enter Symbol:</ControlLabel>
                  <FormControl 
                    type="text" 
                    placeholder="" 
                    value={this.state.symbol} 
                    name="symbol" 
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })} />
                </FormGroup>
                <FormGroup controlId="sector">
                  <ControlLabel>Select Sector:</ControlLabel>
                  <Dropdown 
                    value={this.state.sector}
                    options={sectors} 
                    onChange={(value) => this.setState({ sector: value })} />
                </FormGroup>
                {this.renderAlert()}
                <Button 
                  className="submit-right btn-blue" 
                  bsStyle="primary"
                  onClick={() => this.onFinish('add')}
                >Add</Button>
                <Button 
                  className="submit-left btn-blue" 
                  bsStyle="primary" 
                  onClick={() => this.onFinish('remove')}
                >Remove</Button>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default" 
            onClick={() => this.closeModal()}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AddRemoveModal;